module.exports = __webpack_public_path__ + "d4c7e910d112289a33248e4f4e53dc16.png";